<script setup>
import { ref, computed, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import { useUserGroupStore } from '@/stores/user-group'
import Modal from '@/components/UTAModal.vue'

const emit = defineEmits(['userGroupSelected'])

const userGroupStore    = useUserGroupStore()
const translaterStore   = useTranslaterStore()

const getTranslate          = computed(() => translaterStore.getTranslate)
const userGroupsList        = computed(() => userGroupStore.userGroupsList)
const userGroupUpdateMsg    = computed(() => userGroupStore.userGroupUpdateMsg)

const pageNumber        = ref(1)
const inputSearch       = ref('') 
const showGroupsModal   = ref(false)

userGroupStore.readUserGroups()
userGroupStore.setUserGroupUpdateMsg({})

function prevPage(cursor) {

    let params = {

        'c.limit': 6, 
        'c.direction': 'before', 
        'c.cursor': cursor
    }

    if(inputSearch.value) 
        params['c.q'] = inputSearch.value

    userGroupStore.readUserGroups(params).then(() => {

        pageNumber.value--
    })
}

function nextPage(cursor) {

    let params = {

        'c.limit': 6, 
        'c.direction': 'after', 
        'c.cursor': cursor
    }

    if(inputSearch.value) 
        params['c.q'] = inputSearch.value

    userGroupStore.readUserGroups(params).then(() => {

        pageNumber.value++
    })
}

watch(inputSearch, text => {

    text.length > 2 ? 
        userGroupStore.readUserGroups({ 'c.limit': 6, 'c.q': text }) :
        userGroupStore.readUserGroups({ 'c.limit': 6 })
})

</script>

<template>
    <div class="uta-user-group">
        <span class="uta-user-group__select" @click="showGroupsModal = true">
            {{ getTranslate.BTN_SELECT }}
        </span>
        <div class="uta-user-group__change">
            <Modal 
                v-if="showGroupsModal"
                :header="getTranslate.USER_GROUPS"
                size="lg"
                @closeModal="
                    showGroupsModal = false, 
                    userGroupStore.setUserGroupUpdateMsg({})
                "
            >
                <template v-slot:body>

                    <div class="uta-carusers-create__search mb-4">
                        <div class="input-wrapper">
                            <input 
                                type="text" 
                                :placeholder="getTranslate.SEARCH" 
                                class="form-control input-wrapper__input"
                                v-model="inputSearch"
                            >
                            <template v-if="inputSearch.length > 2">
                                <span class="material-icons input-wrapper__icon" @click="inputSearch = ''">
                                    cancel
                                </span>
                            </template>
                        </div>
                    </div>

                    <div 
                        v-if="'success' in userGroupUpdateMsg && !userGroupUpdateMsg.success"
                        class="alert uta-alert--danger" 
                    >
                        <span class="material-icons alert__icon">
                            error_outline
                        </span>
                        <div class="alert__text">
                            {{ userGroupUpdateMsg.text }}
                        </div>
                        <button type="button" class="btn-close alert__close" aria-label="Close" @click="userGroupStore.setUserGroupUpdateMsg({})"></button>
                    </div>

                    <div class="uta-list" v-if="userGroupsList.array">
                        <div class="uta-list__item" v-for="userGroup in userGroupsList.array" :key="userGroup.uuid">
                            <a 
                                href="#" 
                                class="uta-list__item-link" 
                                @click.prevent="
                                    emit('userGroupSelected', { groupName: userGroup.name, groupUuid: userGroup.uuid }),
                                    showGroupsModal = false
                                ">
                                {{ userGroup.name }}
                            </a> 
                        </div>
                    </div>

                    <div class="uta-user-group__change-list-empty" v-else>
                        {{ getTranslate.USER_GROUPS_EMPTY }}
                    </div>

                    <div class="mb-4 uta-pagination col-24 col-lg-6" v-if="Object.keys(userGroupsList).length && (userGroupsList.c.isBefore || userGroupsList.c.isAfter)">

                        <div class="uta-pagination__prev" :class="{ 'uta-pagination__prev--active' : userGroupsList.c.isBefore }">
                            <template v-if="userGroupsList.c.isBefore">
                                <a href="#" class="uta-pagination__prev-link" @click.prevent="prevPage(userGroupsList.c.start)">
                                    <span class="material-icons">
                                        chevron_left
                                    </span>
                                </a>
                            </template>
                            <template v-else>
                                <span class="material-icons">
                                    chevron_left
                                </span>
                            </template>
                        </div>

                        <div class="uta-pagination__page">
                            {{ pageNumber }}
                        </div>

                        <div class="uta-pagination__next" :class="{ 'uta-pagination__next--active' : userGroupsList.c.isAfter }">
                            <template v-if="userGroupsList.c.isAfter">
                                <a href="#" class="uta-pagination__next-link" @click.prevent="nextPage(userGroupsList.c.stop)">
                                    <span class="material-icons">
                                        chevron_right
                                    </span>
                                </a>
                            </template>
                            <template v-else>
                                <span class="material-icons">
                                    chevron_right
                                </span>
                            </template>
                        </div>

                    </div>

                </template>
            </Modal>
        </div>
    </div>
</template>

<style lang="scss">
@import '@/assets/styles/scss/components/user/user-group';
</style>